import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const ModalProyecto = ({
  show,
  onHide,
  onSave,
  proyecto,
}) => {
  const [nombre, setNombre] = useState("");
  const [pais, setPais] = useState("");
  const [departamento, setDepartamento] = useState("");
  const [provincia, setProvincia] = useState("");
  const [distrito, setDistrito] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (proyecto) {
      setNombre(proyecto.nombre || "");
      setPais(proyecto.pais || "");
      setDepartamento(proyecto.departamento || "");
      setProvincia(proyecto.provincia || "");
      setDistrito(proyecto.distrito || "");
    } else {
      setNombre("");
      setPais("");
      setDepartamento("");
      setProvincia("");
      setDistrito("");
    }
    setError("");
  }, [proyecto, show]);

  const handleSave = () => {
    if (!nombre.trim() || !pais.trim() || !departamento.trim() || !provincia.trim() || !distrito.trim()) {
      setError("Todos los campos son obligatorios");
      return;
    }

    const proyectoData = {
      nombre: nombre.trim(),
      pais: pais.trim(),
      departamento: departamento.trim(),
      provincia: provincia.trim(),
      distrito: distrito.trim(),
    };

    onSave(proyectoData);
  };

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          {proyecto ? "Editar Proyecto" : "Nuevo Proyecto"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <div className="alert alert-danger">{error}</div>}
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Nombre del Proyecto *</Form.Label>
            <Form.Control
              type="text"
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
              placeholder="Ingrese el nombre del proyecto"
              required
            />
          </Form.Group>
          
          <Form.Group className="mb-3">
            <Form.Label>País *</Form.Label>
            <Form.Control
              type="text"
              value={pais}
              onChange={(e) => setPais(e.target.value)}
              placeholder="Ingrese el país"
              required
            />
          </Form.Group>
          
          <Form.Group className="mb-3">
            <Form.Label>Departamento *</Form.Label>
            <Form.Control
              type="text"
              value={departamento}
              onChange={(e) => setDepartamento(e.target.value)}
              placeholder="Ingrese el departamento"
              required
            />
          </Form.Group>
          
          <Form.Group className="mb-3">
            <Form.Label>Provincia *</Form.Label>
            <Form.Control
              type="text"
              value={provincia}
              onChange={(e) => setProvincia(e.target.value)}
              placeholder="Ingrese la provincia"
              required
            />
          </Form.Group>
          
          <Form.Group className="mb-3">
            <Form.Label>Distrito *</Form.Label>
            <Form.Control
              type="text"
              value={distrito}
              onChange={(e) => setDistrito(e.target.value)}
              placeholder="Ingrese el distrito"
              required
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancelar
        </Button>
        <Button variant="primary" onClick={handleSave}>
          {proyecto ? "Actualizar" : "Crear"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalProyecto;
